import fortuneWheel from './modules/fortune-wheel';
import limitRewardActivity from './modules/limit-reward-activity';
import poemRecitation from './modules/poem-recitation';
import mysteryBox from './modules/mystery-box-center';
import reportListen from './modules/report-listen';

export default {
	state: () => ({}),
	mutations: {},
	actions: {},
	getters: {},

	//	嵌套模块,继承父模块的命名空间
	modules: {
		fortuneWheel,
		limitRewardActivity,
		poemRecitation,
		mysteryBox,
		reportListen,
	},
};



// WEBPACK FOOTER //
// ./src/store/Activity/index.js